import { createFileRoute } from '@tanstack/react-router';
import { ExternalIntegrationRouteView } from '@/pages/workspaces/integrations/external-integration/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The catch-all connector detail page. Static siblings (`customerio`,
 * `mparticle_out`, `warehouse`, …) take precedence over this dynamic segment, so
 * it only matches ids the catalog owns.
 *
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this page.
 */
function ExternalIntegrationRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <ExternalIntegrationRouteView type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/$type')({
  component: ExternalIntegrationRoute,
});
